export default __webpack_public_path__ + "static/melttogether-e1e43e9dbed4eb40128dcd085ab5b75b.png";